import CloseIcon from '@mui/icons-material/Close';

import useScopedLocalStorage from '@/shared/hooks/localStorage/useScopedLocalStorage';

import CollapsibleSidebarItem from './CollapsibleSidebarItem';
import IconButton from '@/shared/components/buttons/IconButton';
import SidebarItem from './SidebarItem';

type RecentSidebarContentProps<T extends { id: string }> = {
  storageKey: string;
  mainRoute: string;
  title: string;
  icon: React.ReactNode;
  getItemRoute: (item: T) => string;
  getItemTitle: (item: T) => string;
  getItemTooltip?: (item: T) => string | undefined;
  badgeContent?: number;
};

const RecentSidebarContent = <T extends { id: string }>({
  storageKey,
  mainRoute,
  title,
  icon,
  getItemTitle,
  getItemTooltip,
  getItemRoute,
  badgeContent,
}: RecentSidebarContentProps<T>) => {
  const [recentItems, setRecentItems] = useScopedLocalStorage<T[]>(storageKey, [], {
    subscribe: true,
  });

  const removeFromRecentItems = (id: string) =>
    setRecentItems((prevItems) => prevItems.filter((prevItem) => prevItem.id !== id));

  return (
    <CollapsibleSidebarItem
      badgeContent={badgeContent}
      hideCollapse={!recentItems.length}
      icon={icon}
      route={mainRoute}
      title={title}
    >
      {recentItems.map((item) => (
        <SidebarItem
          key={item.id}
          nested
          className="text-xs"
          endAction={
            <IconButton
              color="neutral"
              iconComponent={<CloseIcon className="mr-2 w-4" />}
              onClick={() => removeFromRecentItems(item.id)}
            />
          }
          route={getItemRoute(item)}
          title={getItemTitle(item)}
          toolTip={getItemTooltip?.(item)}
        />
      ))}
    </CollapsibleSidebarItem>
  );
};

export default RecentSidebarContent;
